import React, { useState } from 'react';
import { getIn } from 'formik';
import { ErrorField } from '../error-field';
import { object, shape, string, oneOfType } from 'prop-types';
import { DateTimePicker, MuiPickersUtilsProvider, } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

export const DateTimeFieldWithError = (
  {
    field,
    form,
    ...props
  }) => {
  const errorText =
    getIn(form.touched, field.name) && getIn(form.errors, field.name);

  // DateTimePicker can handle both Date objects and strings
  const fieldValue = field.value instanceof Date ? field.value : field.value;

  return (
    <React.Fragment>
      <div className="date-picker">
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DateTimePicker
            format="dd/MM/yyyy/ hh:mm a"
            placeholder="DD/MM/YYYY HH:MM AM/PM"
            {...field}
            value={fieldValue}
            {...props}/>
        </MuiPickersUtilsProvider>
      </div>
      {/*{errorText && <ErrorField value={errorText}/>}*/}
    </React.Fragment>
  );
};

DateTimeFieldWithError.propTypes = {
  field: shape({
    name: string,
    value: oneOfType([string, object]), // Can be string or Date object
  }).isRequired,
  form: object,
};
